(() => {
  const designerPath = '/pages/neon-customizer';
  const fanChainPath = '/pages/custom-neon-fan-chains';
  const theme = window.Shopify?.theme;
  const previewId = theme?.role === 'unpublished' ? String(theme.id) : '';
  const storeHosts = new Set([window.location.hostname, 'miamineons.com', 'www.miamineons.com', window.Shopify?.shop].filter(Boolean));
  const aliases = new Map([
    ['/pages/neon-customizer', designerPath],
    ['/product/neon-customizer', designerPath],
    ['/products/neon-customizer', designerPath],
    ['/products/ai-customizer-product', designerPath],
    ['/pages/podcast-neon-signs', '/products/podcast-neon-signs'],
    ['/collections/custom-neon-signs', '/collections/custom-neon-sign'],
    ['/product-category/uncategorized', '/collections/custom-neon-sign']
  ]);
  const decode = (value) => {
    for (let i = 0; i < 2; i += 1) {
      try {
        const next = decodeURIComponent(value);
        if (next === value) break;
        value = next;
      } catch { break; }
    }
    return value;
  };
  const normalize = (link) => {
    if (!link?.matches?.('a[href]') || link.hasAttribute('download')) return;
    const raw = link.getAttribute('href');
    if (!raw || raw.startsWith('#')) return;
    if (/^tel:/i.test(raw)) {
      const number = decode(raw.slice(4)).replace(/[^\d+]/g, '');
      if (!number) return;
      const target = 'tel:' + (number.length === 10 ? '+1' + number : number);
      if (target !== raw) link.setAttribute('href', target);
      return;
    }
    if (/^mailto:/i.test(raw)) {
      const email = decode(raw.slice(7).split('?')[0]).match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i)?.[0];
      if (!email) return;
      const query = raw.includes('?') ? raw.slice(raw.indexOf('?')) : '';
      const target = 'mailto:' + email + query;
      if (target !== raw) link.setAttribute('href', target);
      return;
    }
    let url;
    try { url = new URL(raw, window.location.href); } catch { return; }
    if (!/^https?:$/.test(url.protocol)) return;
    const legacy = url.hostname === 'customizer.miamineons.com';
    if (!legacy && !storeHosts.has(url.hostname)) return;
    let path = url.pathname.replace(/\/+$/, '') || '/';
    if (legacy) {
      path = /fan[-_]?chain/i.test(path + url.search) ? fanChainPath : designerPath;
    } else {
      path = aliases.get(path) || path;
    }
    if (/^\/(?:checkout|checkouts)(?:\/|$)/.test(path) || /^\/cart\/(?:add|change|update|clear)(?:\.|\/|$)/.test(path)) return;
    if (previewId) {
      url.searchParams.set('preview_theme_id', previewId);
      url.searchParams.set('pb', '0');
    }
    const target = path + url.search + url.hash;
    if (target !== raw) link.setAttribute('href', target);
    if (path === designerPath || path === fanChainPath) link.removeAttribute('target');
  };
  const scan = (root) => {
    normalize(root);
    root.querySelectorAll?.('a[href]').forEach(normalize);
  };
  const start = () => {
    scan(document);
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'attributes') normalize(record.target);
        else record.addedNodes.forEach((node) => { if (node.nodeType === 1) scan(node); });
      }
    });
    observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
    document.addEventListener('click', (event) => normalize(event.target.closest?.('a[href]')), true);
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
